import React, { useEffect, useState } from "react";
import SkeletonTable from "../../components/table/SkeletonTable.jsx";
import columns from "../../columns/reviewTax/reviewTax.js";
import viewTaxColumns from "../../columns/reviewTax/viewReviewTax.js";
import Eye from "../../assets/Eye.jsx";
import ModalComponent from "../../components/modals/ModalComponent.jsx";
import { Button, Select } from "antd";
import { GetTaskWiseOrganizerApi } from "../../api/request/taskManager/taskManager.js";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { GetTagListApi } from "../../api/request/settings/tags.js";
import Spinner from "../../components/loaders/Spinner.jsx";
import { AddOrganizerTagApi } from "../../api/request/organizers/organizers.js";

export default function ReviewTax() {
  const navigate = useNavigate();
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [organizerData, setOrganizerData] = useState([]);
  const [tags, setTags] = useState([]);

  const getOrganizers = async () => {
    try {
      setIsLoading(true);
      let params = {
        task_order: "task3",
      };
      const { data } = await GetTaskWiseOrganizerApi(params);
      if (data?.status) {
        setData(
          data?.data?.map((item) => {
            return {
              ...item,
              name: item?.user?.name,
              email: item?.user?.email,
              organizer: (
                <div className="font-bold highlight-text capitalize">
                  {item?.organizer_name_slug}
                </div>
              ),
              submit: item?.is_submit ? "Yes" : "No",
              tag: (
                <Select
                  placeholder="Select tag"
                  style={{ width: "100%" }}
                  value={item?.task_tag}
                  options={tags}
                  onChange={(value) =>
                    tagHandler(item?.id, value, item?.task_tag)
                  }
                />
              ),
              startDate: item?.submitted_date
                ? moment(item?.submitted_date).format("lll")
                : "",
              due: (
                <p
                  className={`${
                    item?.is_due ? "text-red-600" : "text-green-500"
                  }`}
                >
                  {item?.is_due ? "Yes" : "No"}
                </p>
              ),
              dueDate: item?.due_date
                ? moment(item?.due_date).format("lll")
                : "",
              status: (
                <p
                  className={`${item?.status == "active" ? "text-green-500" : "text-red-600"
                    } font-bold uppercase`}
                >
                  {item?.status}
                </p>
              ),
              action: (
                <div
                  className="cursor-pointer"
                  onClick={() => navigate(`/review_tax/${item?.id}`)}
                >
                  <Eye />
                </div>
              ),
            };
          })
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  const getOrganizerTags = async () => {
    try {
      setIsLoading(true);
      const { data } = await GetTagListApi({ type: "organizer" });
      if (data.status) {
        setTags(
          data?.data?.map((item) => {
            return { value: item?.name };
          })
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getOrganizerTags();
    setOrganizerData(
      organizerData?.map((item) => {
        return {
          ...item,
          question: (
            <div
              className={`${!item?.review ? "font-semibold highlight-text" : ""
                }`}
            >
              {item?.question}
            </div>
          ),
          review: (
            <div className="cursor-pointer">
              <img
                className="size-7"
                src={
                  item?.review
                    ? "/assets/icons/outlined-check-circle.svg"
                    : "/assets/icons/outlined-circle.svg"
                }
              />
            </div>
          ),
        };
      })
    );
  }, []);

  useEffect(() => {
    getOrganizers();
    if (tags?.length > 0) {
      columns.map((item) => {
        if (item.dataIndex === "tag") {
          item.filters = tags.map((filter) => {
            return { text: filter?.value, value: filter?.value };
          });
        }
      });
    }
  }, [tags]);

  const setTagData = (id, tag) => {
    setData((prev) => {
      return prev.map((item) =>
        item.id === id
          ? {
            ...item,
            task_tag: tag,
            tag: (
              <Select
                placeholder="Select tag"
                style={{ width: "100%" }}
                value={tag}
                options={tags}
                onChange={(value) => tagHandler(item?.id, value, tag)}
              />
            ),
          }
          : item
      );
    });
  };

  const tagHandler = async (id, tag, currentTag) => {
    if (tag === currentTag) return;

    try {
      setData((prev) => {
        return prev.map((item) =>
          item.id === id ? { ...item, tag: <Spinner /> } : item
        );
      });

      let params = { org_id: id, tags: tag };
      const { data } = await AddOrganizerTagApi(params);
      if (data?.status) setTagData(id, tag);
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
      setTagData(id, currentTag);
    }
  };

  return (
    <div>
      <div className="border-2 rounded-xl">
        <div className="mt-4 mx-5">
          <p className="font-semibold text-xl">Organizers</p>
        </div>
        <div className="table-radius-0 text-light my-4">
          <SkeletonTable
            searchingFields={["name", "email"]}
            dateFilterFields = {["startDate", "dueDate"]}
            columns={columns}
            data={data}
            isLoading={isLoading}
          />
        </div>
      </div>

      <ModalComponent
        isOpen={isOpenModal}
        setIsOpen={setIsOpenModal}
        closable={false}
        title="2023 Individual Tax Organizer"
        width={900}
      >
        <div className="mt-2 pb-5 border rounded-lg text-light">
          <SkeletonTable
            columns={viewTaxColumns}
            data={organizerData}
            isLoading={isLoading}
          />
        </div>
        <div className="flex justify-center mt-5">
          <Button
            type="primary"
            className="uppercase font-semibold"
            onClick={() => setIsOpenModal(false)}
          >
            Complete task
          </Button>
        </div>
      </ModalComponent>
    </div>
  );
}
